import React from 'react';

import { MeetingIconBtn } from './Button';

import { Card, CardActions, CardContent, makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({

    root : {
        height: '8vh',
        display : 'flex',
        alignItems : 'center',
        justifyContent : 'flex-end',
        textAlign : 'center',
        padding: '0 16px',
        borderRadius: '24px',
        lineHeight: '24px',
        letterSpacing: '-0.011em',
        backgroundColor : ' #1c1c1c',
        color : '#e7e5eb',
        '&:hover' : {
            border : '0',
            backgroundColor : ' #1c1c1c',
            color : '#e7e5eb',
        }
    },
    content: {
        display : 'flex',
        alignSelf : 'center',
        width : '100%',
        justifyContent : 'center',
        fontFamily: 'primary !important',
        fontWeight: '800 !important',
        fontSize: '1.2rem !important',
    },
    button : {
        justifySelf : 'flex-end',
    }
}));

const Capsule = function Capsule({ name, roomNameCallBack }) {

    const classes = useStyles();

    var handleLocalRoomClick = () => {

        roomNameCallBack();

    }

    return(
        <Card classes={{ root : classes.root }}  onClick={handleLocalRoomClick} >
            <CardContent classes={{ root : classes.content }} >
                { name.length > 9 ? name.slice(0,5) + '...' + name.slice(name.length-3,) : name }
            </CardContent>
            <CardActions classes={{ root: classes.button }} >
                <MeetingIconBtn view="desktop" handleClick={handleLocalRoomClick} />
            </CardActions>
        </Card>
    );
        
    }

export default Capsule;